import React from 'react';
import 'twin.macro';
import { StaticImage } from 'gatsby-plugin-image';

import CardLink, { cardLinkImageStyles } from '~components/Card/CardLink';
import Heading from '~components/Heading';
import Text, { Bold } from '~components/Text';
import Quote from '~components/Quote';

import T1D from '~components/Svg/T1D';

const Momentum: React.FC = () => (
  <>
    <div tw="flex items-center justify-between space-x-6 my-12">
      <div>
        <Text>
        Alors que nous cherchons à recueillir des fonds pour faire avancer les nouvelles recherches sur le DT1, les donateurs et les défenseurs de FRDJ démontrent leur engagement envers les Canadiens touchés par le DT1 par leur philanthropie et leur soutien. 
        </Text>
        <Bold>Ensemble, ils accélèrent le rythme du changement.</Bold>
      </div>
      <T1D tw="flex-shrink-0 h-20 w-auto text-blue md:(h-36)" />
    </div>
    <div tw="my-12 lg:(flex items-start space-x-6)">
      <div>
        <Heading level="h2" tw="text-blue-800 mt-0">
        Le Fonds DT1
        </Heading>
        <Text tw="max-w-3xl">
        En 2016, un groupe de bénévoles de FRDJ a identifié que le manque d’investissement en capital-risque en sciences de la vie dans le diabète de type 1 (DT1) était l’un des principaux obstacles à la progression vers une guérison. Pour surmonter cet obstacle, FRDJ a créé le Fonds DT1 — une combinaison de capital de risque et de philanthropie axée uniquement sur l’accélération du développement de produits commerciaux et de thérapies pour le DT1.
        </Text>
        <Bold tw="max-w-3xl">
        Guérir la maladie exige la coopération d’une mosaïque de sympathisants. Il y a cinq ans, il nous manquait une pièce cruciale du casse-tête. 
        </Bold>
        <Text tw="max-w-3xl">
        Lorsque les donateurs soutiennent ce fonds, leurs investissements soutiennent les entreprises qui se concentrent sur les médicaments, les appareils, les outils de diagnostic et d’autres solutions de santé avec des applications au DT1. Le Fonds DT1 choisit des sociétés qui peuvent avoir le plus grand impact clinique sur le DT1, ce qui conduit à une meilleure gestion de la maladie et à des traitements potentiels.
        </Text>
        <Text tw="max-w-3xl">
        Le Fonds DT1 est désormais le plus grand fonds de philanthropie de risque axé sur une seule maladie au monde. En seulement quatre ans, notre Fonds et ses partenaires de capital-risque ont investi un montant incroyable de 500 millions de dollars dans des programmes DT1. Le nombre d’entreprises travaillant sur les thérapies du DT1 est passé d’une poignée à plus de 30 sociétés pharmaceutiques et biotechnologiques, soutenues par plus de 85 donateurs dans le monde et plus de 30 bailleurs de fonds de capital-risque et de biotechnologie. Cela a également conduit à plusieurs développements passionnants dans le domaine du DT1 et à des acquisitions majeures de jeunes entreprises soutenues par le Fonds DT1. 
        </Text>
        <Text tw="max-w-3xl">
        D’autres sociétés financées par le Fonds DT1 testent de nouvelles thérapies potentielles intéressantes. Le modèle du Fonds DT1 fonctionne et donc, en 2020, les bases ont été jetées pour inclure ce concept unique dans la Campagne pour accélérer de FRDJ Canada avec pour objectif de recueillir 10 millions de dollars pour le Fonds DT1. Deux bénévoles principaux de longue date, Terry Jackson et Geoff Beattie, ont co-présidé cette initiative. Avec leurs familles, ils deviennent également les premiers investisseurs canadiens dans le Fonds DT1.
        </Text>
        <Quote>
        « En ce qui concerne le diabète, la recherche d’une guérison peut sembler lente », explique Geoff, dont sa fille a été diagnostiquée à l’âge de 4 ans. Mais je me concentre sur les progrès des 20 dernières années, et je sais qu’à mesure que le rythme de la compréhension augmente, une guérison pourrait bien être en vue. Le Fonds DT1 est une proposition unique pour accélérer la commercialisation des produits contre le diabète de type 1, combinant l’expertise mondiale de la recherche de FRDJ avec une équipe de gestion de fonds de classe mondiale. Je suis convaincu que ce sera une initiative clé qui raccourcira la course pour trouver une guérison.
        </Quote>
      </div>
      <div tw="hidden lg:(block w-2/5 flex-shrink-0)">
        <StaticImage
          src="../../images/illustration-of-a-child-being-stalked-by-diabetes.png"
          alt=""
          layout="fullWidth"
        />
      </div>
    </div>
    <div tw="lg:(w-10/12)">
      <CardLink
        variant="blue"
        to="/momentum-for-change/benyk-maher-gift"
        title="Le don de la famille Wendy Benyk et Ray Maher"
      >
        <StaticImage
          src="../../images/wendy-benyk-and-ray-mahers-family.jpg"
          alt=""
          style={cardLinkImageStyles}
          layout="fullWidth"
        />
      </CardLink>
      <div tw="my-12 grid gap-12 lg:(grid-cols-3)">
        <div tw="lg:(col-span-2)">
          <CardLink
            to="/momentum-for-change/jacksons-story/"
            title="L’histoire de Bonnie et Terry Jackson"
            variant="blue"
          >
            <StaticImage
              src="../../images/bonnie-and-terry-jackson.jpg"
              alt=""
              style={cardLinkImageStyles}
              layout="fullWidth"
            />
          </CardLink>
        </div>
        <div tw="lg:(col-span-1)">
          <CardLink
            to="/momentum-for-change/beatties-story"
            title="L'histoire de Geoff Beattie"
            variant="blue"
          >
            <StaticImage
              src="../../images/geoff-beatie-large.jpg"
              alt=""
              style={cardLinkImageStyles}
              layout="fullWidth"
            />
          </CardLink>
        </div>
      </div>
    </div>
  </>
);

export default Momentum;
